import * as React from 'react';
import { Stack } from '@mui/material';

const Footer = () => {
  return (
    <Stack sx={{ backgroundColor: 'lightgrey' }} alignItems="center" py={2}>
      Copyright Zuzana Bořutová
    </Stack>
  );
};

export default Footer;
